__turbopack_context__.v({
  "caret": "locale-switcher-module__Wy4jOq__caret",
  "caretOpen": "locale-switcher-module__Wy4jOq__caretOpen",
  "container": "locale-switcher-module__Wy4jOq__container",
  "current": "locale-switcher-module__Wy4jOq__current",
  "dropdown": "locale-switcher-module__Wy4jOq__dropdown",
  "glassLayer": "locale-switcher-module__Wy4jOq__glassLayer",
  "globeIcon": "locale-switcher-module__Wy4jOq__globeIcon",
  "option": "locale-switcher-module__Wy4jOq__option",
  "optionActive": "locale-switcher-module__Wy4jOq__optionActive",
  "selectContentLocale": "locale-switcher-module__Wy4jOq__selectContentLocale",
  "selectItemCode": "locale-switcher-module__Wy4jOq__selectItemCode",
  "selectItemIndicatorLocale": "locale-switcher-module__Wy4jOq__selectItemIndicatorLocale",
  "selectItemLocale": "locale-switcher-module__Wy4jOq__selectItemLocale",
  "selectItemText": "locale-switcher-module__Wy4jOq__selectItemText",
  "selectTriggerLocale": "locale-switcher-module__Wy4jOq__selectTriggerLocale",
  "selectViewportLocale": "locale-switcher-module__Wy4jOq__selectViewportLocale",
  "trigger": "locale-switcher-module__Wy4jOq__trigger",
});
